function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export default function CatRunningReadyItemFrame({
  children,
  className = '',
  contentClassName = '',
  isSelected = false,
}) {
  return (
    <div
      className={joinClassNames(
        'relative mx-auto h-[158px] w-[170px] transition-transform duration-150',
        isSelected ? 'scale-[1.02]' : '',
        className,
      )}
    >
      {isSelected && <div className="absolute inset-[10px] z-[2] border-2 border-white/80 pointer-events-none" />}
      <div className="absolute left-[21px] top-[7px] h-[144px] w-[128px] bg-black" />
      <span className="absolute left-[14px] top-[14px] h-[130px] w-[7px] bg-black" />
      <span className="absolute left-[7px] top-[21px] h-[116px] w-[7px] bg-black" />
      <span className="absolute left-[149px] top-[14px] h-[130px] w-[7px] bg-black" />
      <span className="absolute left-[156px] top-[21px] h-[116px] w-[7px] bg-black" />

      <span className="absolute left-[21px] top-0 h-[7px] w-[128px] bg-[#333333]" />
      <span className="absolute left-[21px] top-[151px] h-[7px] w-[128px] bg-[#333333]" />
      <span className="absolute left-0 top-[21px] h-[116px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[163px] top-[21px] h-[116px] w-[7px] bg-[#333333]" />

      <span className="absolute left-[14px] top-[7px] h-[7px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[7px] top-[14px] h-[7px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[149px] top-[7px] h-[7px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[156px] top-[14px] h-[7px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[7px] top-[137px] h-[7px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[14px] top-[144px] h-[7px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[156px] top-[137px] h-[7px] w-[7px] bg-[#333333]" />
      <span className="absolute left-[149px] top-[144px] h-[7px] w-[7px] bg-[#333333]" />

      <div
        className={joinClassNames(
          'absolute left-[21px] top-[7px] z-[1] flex h-[144px] w-[128px] items-start justify-center px-3 py-[10px]',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
